export enum EPriceQueryKey {
  MARKET_PRICE_PERFORMANCE = 'market-price-performance',
  PRICE_PERFORMANCE = 'price-performance',
  PRICE_TS = 'price-ts',
  PRICE_CHART_SNAPSHOT = 'price-chart-snapshot',
}
